import React, {useState} from 'react'
import OrderCard from './OrderCard'
import CustomButton from '../edit/customer/CustomButton'
import clsx from 'clsx'
import {Notes} from './Notes'

interface Props {
  showToolbar?: boolean
  note: string | any
  onValueChange: (data: any) => void
  isOpenEditMode?: boolean
  title?: string
  notes?: any[]
  onClick?: (val: any) => void
  toolbarTitle?: string
}

export const CustomerNotes: React.FC<Props> = ({
  showToolbar,
  onValueChange,
  note,
  isOpenEditMode,
  title = 'Notes',
  onClick,
  toolbarTitle,
  notes,
}) => {
  const [isEditMode, setIsEditMode] = useState(isOpenEditMode || false)

  const handleClick = () => {
    if (onClick) {
      onClick(!isEditMode)
    } else {
      setIsEditMode(!isEditMode)
    }
  }

  const handleChange = (e: any) => {
    const {value} = e.target
    onValueChange(value)
  }

  return (
    <OrderCard
      title={title}
      toolbar={
        <>
          {showToolbar && (
            <CustomButton onClick={handleClick}>
              {toolbarTitle ? toolbarTitle : !isEditMode ? 'Edit' : 'View'}
            </CustomButton>
          )}
        </>
      }
      className={clsx(!isEditMode && 'd-none')}
      isCustomFooter={notes && <Notes notes={notes} />}
    >
      {isEditMode && (
        <textarea
          className='form-control'
          rows={5}
          value={note}
          onChange={handleChange}
          placeholder='Enter a description...'
        />
      )}
    </OrderCard>
  )
}

export default CustomerNotes
